export default __webpack_public_path__ + "static/media/planning.2f51bf5c.svg";